import { render } from "./008-VRParkPage.vue?vue&type=template&id=6f96cd37&scoped=true"
import script from "./008-VRParkPage.vue?vue&type=script&lang=js"
export * from "./008-VRParkPage.vue?vue&type=script&lang=js"

import "@/assets/css/news.css?vue&type=style&index=0&id=6f96cd37&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f96cd37"]])

export default __exports__